import React, { useMemo } from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { getUserPhotoSource } from '../../utils/userPhoto';

export function TourPartyMemberAvatar({ member, size = 40, theme, style }) {
  const source = useMemo(
    () =>
      getUserPhotoSource(
        {
          id: member?.id,
          uid: member?.id,
          email: member?.email,
          photoURL: member?.photoURL,
        },
        true
      ),
    [member?.email, member?.id, member?.photoURL]
  );
  const styles = useMemo(() => createStyles(theme, size), [theme, size]);

  return (
    <View style={[styles.wrap, style]}>
      <Image source={source} style={styles.image} resizeMode="cover" />
    </View>
  );
}

function createStyles(theme, size) {
  return StyleSheet.create({
    wrap: {
      width: size,
      height: size,
      borderRadius: size / 2,
      overflow: 'hidden',
      borderWidth: 1.5,
      borderColor: theme.ui.border,
      backgroundColor: theme.background.elevated,
    },
    image: {
      width: size,
      height: size,
    },
  });
}

export default TourPartyMemberAvatar;
